<template>
    <div class="login-view" :style="setBackground">
        <HeaderBar v-show="hasHeader"/>
        <div class="logo-wrap">
            <img class="logo-img" src="../../assets/images/logoyl.png" alt="logo" />
        </div>
        <div class="form-wrap">
            <div class="field-item" @click="shareIos">
                <img class="uploadImg" src="../../assets/images/please_ios.png" alt="ios" />
            </div>
            <div class="field-item itemtop" @click="shareAndriod">
                <img class="uploadImg" src="../../assets/images/please_andriod.png" alt="android" />
            </div>
        </div>

        <div class="field-pease">
            <div class="pease-text">
                邀请码:<span class="field-ipt">{{yqcode}}</span>
            </div>
            <div class="pease-item" @click="copyCode">
                <img class="imgPlease" src="../../assets/images/pleaseCode.png" alt="pleaseCode"/>
            </div>
        </div>
    </div>
</template>
<script>
    import { Button, Checkbox, Switch,Toast } from 'vant';
    import HeaderBar from '../../components/HeaderBar';
    import {handleClipboard} from '../../assets/js/clipboard'
    export default {
        name: 'share',
        components: {
            'van-button': Button,
            'van-checkbox': Checkbox,
            'van-switch': Switch,
            HeaderBar
        },

        data() {
            return {
                mobile: '',
                identifying_code: '',
                invite_code: '',
                countingDown: 0,
                account: '',
                password: '',
                rememberPass: false,
                setBackground: {
                    backgroundImage: "url(" + require("../../assets/images/please_bg.png") + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "100% 100%",
                    backgroundSize: "100% 100%",
                    backgroundAttachment:"fixed",
                },
                yqcode:'',
                hasHeader:this.$route.query.hasHeader,
            };
        },
        created(){
            let urlStr = window.location.href;
            let course_id =urlStr.substr(urlStr.indexOf("fxcode")+7);
            this.yqcode = course_id;

        },

        methods: {
            copyCode(){
                handleClipboard(this.yqcode, event, () => {
                    Toast('复制成功')
                }, () => {
                    Toast('复制失败')
                })
            },
            shareIos(){
                window.location.href='https://apps.apple.com/cn/app/友绿/id1473079601?l=zh&ls=1';
            },
            shareAndriod(){
                window.location.href='https://sj.qq.com/myapp/detail.htm?apkName=com.greenman';
            }
        }
    };
</script>
<style lang="stylus" scoped>
    .login-view {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .logo-wrap {
            .logo-img {
                width: 151px;
                height: 239px;
            }

        }

        .form-wrap {
            margin-top:91px;
            display: flex;
            flex-direction column;
            align-items center;
            .field-item {
                .uploadImg {
                    width:322px;
                    height:97px;

                }
            }
            .itemtop{
                margin-top:32px;
            }
        }

        .field-pease{
            margin-top:71px;
            display flex;
            flex-direction column;
            justify-content center;
            align-items center;
            .pease-text {
                width 300px;
                height 24px;
                font-size 25px;
                color #000000;
                line-height 24px;
                .field-ipt{
                    text-align: right;
                    padding-left:10px;
                    color: #000
                }
                
            }
            .pease-item{
                margin-top:34px;
                .imgPlease {
                    width: 280px;
                    height: 50px;
                }
            }

        }
    }
</style>
